import * as jose from 'jose';

/**
 * Service to fetch and update resources from Google Sheets.
 */

// Service account credentials for Google Sheets API
const SERVICE_ACCOUNT_CREDENTIALS = {
  "type": "service_account",
  "project_id": "greta-ratings-integration",
  "private_key_id": "47f987287032aeb6994a1de90701f56ed168a373",
  "private_key": "-----BEGIN PRIVATE KEY-----\nMIIEvwIBADANBgkqhkiG9w0BAQEFAASCBKkwggSlAgEAAoIBAQCxEhtXlzlMoiNu\nQXNu8gas3odewHgmfMFy+Thsk5WmsF+VPOBJIwAoAsbNgjFO9iI/RK/defxiXcrQ\nnXapzo5FTXh2W7Wxownbdr7gqFNfwJE1MM6bnkNBPeUaGc53IYJ5jLUl5Q/rporX\nfq5iDxmh3ajTWui2LGkBSI9cUrirQgzq3hHMvTKmIP1UIKEDUWn9JLmu5V+n22wQ\n31Z0WW9MGWWJhDD71sGvuNTZ9TgH6NEpgzAHuzO83y8WnCQZNduIl5matpcE84+z\nb65mNfqre5bVnkbUPhH9NpVwJ0HtVYwbwpY93VdSCX0IVCYdXoYpc4uM++Z2SuyV\nPXgcfsabAgMBAAECggEAIx2pKHzIE0eQaTw3rUf4RO44wHTBHzjckHWWWAoIwq71\ntb4F6Ns1G7o5POZV6wfrEMsJaY3YnJVnNGoV72UUV/AeNLLJXLotqUVqY1led33U\nDk1om/oN8nFY7w0xIfUWUA60mhhMSPqVTFlGMhI2jiBMa+X6gq5aALQoIjIRh3zU\nAAznEGLvL2vFpTbusPtzeOV8n15svxgH+j861h3tHfe/q1kJ1qjzLjhBxnUvbQJ5\nQOhkoV45NbRiZcmalsiA2KsI3UNE4bbvrfOcuWRVmj6ML+b/keSjx2HCAy8T0vDu\nFl1tbyrkaPRyzX4yI7UPi3/tp7xnO6cN4lJ7jnoxYQKBgQDrGsOuunDKqBHjkP1S\nq0eAMWkMf3NZaGhMrL25NLlpX2s9xuKtEd+NTUo83Qj6yRvCzZEPdaZ7ATlw9+Ps\nQuBCw0O6Io3fTmvHT/cQIg2O3H3g9WyN3KweO95L4C6MNMLpYyC9ixNxq5b2oQo3\nkqS2ZzmTtNCHZ3bUDw6YgppkMQKBgQDAzuxVYGB3T0AQ0fVQ08+aBEiY5oHMn9Su\nArTiz50fg0j6z2Z14EJe9zutbHyPdMW5QuDw46YDkBD4ZkxFng8CsnXb9Rz+woeE\n2aqOXuy9YauqIKiLWe6c1SY62Zi6F+QFwE3IxYicPjbjQW50/pk1UwdD8KG69lv+\nVvFc0JhgiwKBgQCdiBSAWorDL/S0n+0t3HiPbAwwhKG80dm5LrH9jFeERJxuC3rN\nbsF1Q8mvmIewytpgIC/HxRRlLT/Y8zD0mSb9dStHaGnZrAlJxsoMNFUTWai6+Jfh\nQnDN3V2pR7DI332Oto40kyDXNJt17BgVfpwBYI9S6oAjim8zzlcAV9qtsQKBgQCX\ndva560hc8ekGTapFoN+Jwqu1Uf/N3BGb0YyAUVDBnMUMIzn+h/ob2GUNTBheKgHa\nE+vZ0TxtuBNc0CBC4HQyTfAX8IzcGY9uzD9Px0DeWL990HwlumYUuoBeUc9id8b\nlYKFoog7FbTQumonhoqdFWizuqmS0k5ac7qQi13pGQKBgQCTXjjYYTMYdl6Fcxwg\nho7w1SOaLnoZpe89fInBprGGwce7dUFCrAOfSs8QJjRfCr63EDADGZNHVt2LRkyq\nDOOyM0oqP4DCSpetYWrjNrUEsN+KMaUr3ek4l77stJP47Zfb199QqUmj30Yp+IR1\n7/VH4v9A3cCRGuhzpnfpEu3ZfA==\n-----END PRIVATE KEY-----\n",
  "client_email": "sheet-updater@greta-ratings-integration.iam.gserviceaccount.com",
  "client_id": "100588672711206548458",
  "auth_uri": "https://accounts.google.com/o/oauth2/auth",
  "token_uri": "https://oauth2.googleapis.com/token",
  "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
  "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/sheet-updater%40greta-ratings-integration.iam.gserviceaccount.com",
  "universe_domain": "googleapis.com"
};

// This ID is for the *published* version of the sheet, used for reading public CSV data.
const PUBLISHED_SHEET_URL_ID = '2PACX-1vS0ohnNN4X6DOI2TVtiI737KqiELa3vPhoQLmR-k4ZCngSvii3D5d_MeYrNS-sbSMCMRLHouWuaaqHT';

// ----------------------------------------------------------------------------------
// CRITICAL: You must replace the placeholder below with your REAL Google Sheet ID.
// This ID is found in your sheet's main URL (not the publish URL).
// Example: https://docs.google.com/spreadsheets/d/THIS_IS_THE_ID_YOU_NEED/edit
const SPREADSHEET_ID = '1GzsKrJXlNRTfE59SsEOgrQbCyVcPFo1yOJSr1589kgY';
// ----------------------------------------------------------------------------------

const SHEET_ID = '0'; // First sheet

export const fetchResourcesFromSheet = async () => {
  try {
    const sheetUrl = `https://docs.google.com/spreadsheets/d/e/${PUBLISHED_SHEET_URL_ID}/pub?gid=${SHEET_ID}&single=true&output=csv`;
    const response = await fetch(sheetUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.status}`);
    }
    const csvText = await response.text();
    return parseCSVToJSON(csvText);
  } catch (error) {
    console.error("Error fetching Google Sheet data:", error);
    throw error;
  }
};

const parseCSVToJSON = (csvText) => {
  const rows = csvText.split('\n');
  if (rows.length === 0) return [];
  const headers = parseCSVRow(rows[0]).map(header =>
    header.trim().toLowerCase().replace(/\s+/g, '_').replace(/[^\w_]/g, '')
  );
  const resources = [];
  for (let i = 1; i < rows.length; i++) {
    const row = rows[i].trim();
    if (!row) continue;
    const values = parseCSVRow(row);
    const hasAnyData = values.some(val => val && val.trim() !== '');
    if (hasAnyData) {
      const resource = { id: resources.length + 1 };
      headers.forEach((header, j) => {
        resource[header] = values[j] ? values[j].trim().replace(/"/g, '') : '';
      });
      resources.push(resource);
    }
  }
  return resources;
};

const parseCSVRow = (row) => {
  const values = [];
  let currentValue = '';
  let inQuotes = false;
  for (let i = 0; i < row.length; i++) {
    const char = row[i];
    if (char === '"' && i + 1 < row.length && row[i + 1] === '"') {
      currentValue += '"';
      i++;
    } else if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === ',' && !inQuotes) {
      values.push(currentValue);
      currentValue = '';
    } else {
      currentValue += char;
    }
  }
  values.push(currentValue);
  return values;
};

const getAccessToken = async () => {
  const tokenInfo = JSON.parse(sessionStorage.getItem('googleApiToken'));
  if (tokenInfo && tokenInfo.expiry > Date.now()) {
    return tokenInfo.token;
  }

  const { private_key, client_email } = SERVICE_ACCOUNT_CREDENTIALS;
  const alg = 'RS256';
  const pkcs8 = await jose.importPKCS8(private_key, alg);

  const jwt = await new jose.SignJWT({})
    .setProtectedHeader({ alg })
    .setIssuedAt()
    .setIssuer(client_email)
    .setAudience('https://oauth2.googleapis.com/token')
    .setExpirationTime('1h')
    .setSubject(client_email)
    .setClaim('scope', 'https://www.googleapis.com/auth/spreadsheets')
    .sign(pkcs8);

  const response = await fetch('https://oauth2.googleapis.com/token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
      assertion: jwt,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(`Failed to get access token: ${errorData.error_description}`);
  }

  const data = await response.json();
  const expiry = Date.now() + 55 * 60 * 1000;
  sessionStorage.setItem('googleApiToken', JSON.stringify({ token: data.access_token, expiry }));
  return data.access_token;
};

export const updateGoogleSheetRating = async (rowIndex, newRating) => {
  if (SPREADSHEET_ID === 'PLEASE_REPLACE_WITH_REAL_SPREADSHEET_ID') {
    const errorMessage = "CRITICAL: Cannot update Google Sheet. The SPREADSHEET_ID is a placeholder. Please replace it in src/services/googleSheetService.js with the actual ID from your Google Sheet's URL.";
    console.error(errorMessage);
    alert(errorMessage);
    return false;
  }
  try {
    const accessToken = await getAccessToken();
    const ratingString = ratingToString(newRating);
    const sheetRowIndex = rowIndex + 1;
    const range = `Sheet1!R${sheetRowIndex}`;
    const updateUrl = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${range}?valueInputOption=USER_ENTERED`;

    const response = await fetch(updateUrl, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ values: [[ratingString]] }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Failed to update sheet: ${errorData.error.message}`);
    }
    console.log('Successfully updated rating in Google Sheet:', await response.json());
    return true;
  } catch (error) {
    console.error('Error in updateGoogleSheetRating:', error);
    return false;
  }
};

export const parseRating = (ratingString) => {
  if (!ratingString || typeof ratingString !== 'string') {
    return { up: 0, down: 0, total: 0 };
  }
  const rating = { up: 0, down: 0, total: 0 };
  const parts = ratingString.split(',');
  parts.forEach(part => {
    const [key, value] = part.split(':');
    if (key && value) {
      const numValue = parseInt(value, 10) || 0;
      if (key === 'up') rating.up = numValue;
      else if (key === 'down') rating.down = numValue;
      else if (key === 'total') rating.total = numValue;
    }
  });
  return rating;
};

export const ratingToString = (rating) => {
  return `up:${rating.up},down:${rating.down},total:${rating.total}`;
};

export const isVerified = (rating) => {
  const ratingObj = typeof rating === 'string' ? parseRating(rating) : rating;
  return ratingObj.total >= 10 && (ratingObj.up / ratingObj.total) >= 0.8;
};

export const getUserVote = (resourceId) => {
  try {
    const votes = JSON.parse(localStorage.getItem('resourceVotes') || '{}');
    return votes[resourceId] || null;
  } catch (error) {
    console.error('Error getting user vote:', error);
    return null;
  }
};

export const saveUserVote = (resourceId, voteType) => {
  try {
    const votes = JSON.parse(localStorage.getItem('resourceVotes') || '{}');
    votes[resourceId] = voteType;
    localStorage.setItem('resourceVotes', JSON.stringify(votes));
  } catch (error) {
    console.error('Error saving user vote:', error);
  }
};

export const submitResourceVote = async (resourceId, voteType, currentRating) => {
  try {
    const previousVote = getUserVote(resourceId);
    let newRating = { ...currentRating };

    if (previousVote) {
      if (previousVote === 'up') newRating.up = Math.max(0, newRating.up - 1);
      else if (previousVote === 'down') newRating.down = Math.max(0, newRating.down - 1);
    }

    if (voteType === 'up') newRating.up++;
    else if (voteType === 'down') newRating.down++;
    
    newRating.total = newRating.up + newRating.down;

    const success = await updateGoogleSheetRating(resourceId, newRating);
    if (success) {
      saveUserVote(resourceId, voteType);
    } else {
      throw new Error('Failed to update Google Sheet');
    }
    return newRating;
  } catch (error) {
    console.error('Error submitting resource vote:', error);
    throw error;
  }
};